export default function phone(val, count = 2) {
	const cleaned = String(val).replace(/\D/g, '')
	const match = cleaned.match(/^(1|)?(\d{3})?(\d{3})(\d{4})$/)
	if (match) {
		let intlCode = (match[1] ? '+1 ' : '')
		return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
	}
	return null
}
